import moment from "moment";
import './Footer.css';
import {useTranslation} from "react-i18next";
import {APP_VERSION} from "../../../settings";
import {downloadLogs} from "../../../helpers/LogHelper";
import {useState} from "react";

const Footer = () => {
    const {t} = useTranslation();
    const year = moment().format("YYYY");
    const [logClicks, setLogClicks] = useState(1);

    const versionClick = () => {
        if (logClicks < 5){
            setLogClicks(c => c +1);
        } else {
            setLogClicks(1);
            downloadLogs();
        }
    };
    return (
        <div className="footer-container">
            <div className="flex-grow-1"/>
            <div className="d-flex justify-content-center footer-links">
                <a target="_blank" rel="noopener noreferrer" href="https://binora.com.ua">{t("about_us")}</a>
                <a target="_blank" rel="noopener noreferrer" href="https://binora.com.ua/contact">{t("contacts")}</a>
                <a target="_blank" rel="noopener noreferrer" href="https://my.binora.com.ua/app">{t("mobile_app")}</a>
                <a target="_blank" rel="noopener noreferrer" href="https://my.binora.com.ua/downloads/arnika-latest.zip">{t("desktop_app")}</a>
                {/*<a target="_blank" rel="noopener noreferrer" href="https://binora.com.ua">{t("terms_and_conditions")}</a>*/}
                {/*<a target="_blank" rel="noopener noreferrer" href="https://binora.com.ua/contact">{t("support")}</a>*/}
            </div>
            <div onClick={versionClick} className="d-flex justify-content-center footer-copyrights no-select">{`Copyright © ${year} Binora ${APP_VERSION}. All rights reserved.`}</div>
        </div>
        );
}

export default Footer;